import { TranslatePipe } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'i18nLabel',
  pure: false,
  standalone: false,
})
export class I18nLabelPipe extends TranslatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(`label:${value}`, args);
  }
}
